import { getSiteUrl } from './organization-schema';
import { publicSchemaUrl } from './json-ld';

/** Uses the same labels and links as the visible breadcrumb component. */
export function buildBreadcrumbSchema(
    items: Array<{ name: string; href: string }>, currentName: string, pathname: string,
) {
    const siteUrl = getSiteUrl();
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [...items, { name: currentName, href: pathname }].map((item, index) => ({
            '@type': 'ListItem', position: index + 1, name: item.name,
            item: publicSchemaUrl(item.href, siteUrl),
        })),
    };
}
